import styled from 'styled-components';
import ActionButton from './ActionButton';
import ButtonArrowIcon from '../assets/svg/ButtonArrowIcon';
import { Link } from 'react-router-dom';
import { PUBLIC_IMAGES_REPO } from '../../../utils/Constants';

const BannerImage = `https://images.boostfloral.com/publicImagesRepo/boostfloral -today-image.webp`;
const BannerImageMobile = `https://images.boostfloral.com/publicImagesRepo/boostfloral -today-image-mobile.webp`;

const Wrapper = styled.section`
background: var(--primary-primary-400, #8DD473);

  .container {
    max-width: 1440px;
    display: flex;
    padding: 6.25rem 0px 6.25rem 6.25rem;
    align-items: center;
    position: relative;
    overflow: hidden;
  }

  .content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 48px;
    flex-shrink: 0;
    width: 50%;
    
    .mobile-img{
      display: none;
    }
    

    h2{
      color: var(--font-color-font-4, #FFF);
      font-family: Instrument Sans;
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px;
    }
  }

  .desktop-img{
    display: block;
  }

  .login-now{
    display: flex;
    transform: rotate(17.56deg);
    padding: 6px 12px;
    position: absolute;
    left: 50%;
    top: 30%;
    border-radius: 3px;
    background: var(--primary-primary-600-f, #62AA48);
    border: none;
    color: var(--BG-Color, #F2F2F2);
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  img{
    min-height: 378px;
  }

  @media screen and (max-width: 1024){
    .content{
        h2{
          font-size: 45px;
          line-height: 58px;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      padding: 3rem 0px 3rem 3.25rem;
      flex-direction: column;
    }

    img{
      min-height: 180px;
    }
  
    .content{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 28px;
      flex-shrink: 0;
      width: 100%;
      
      .mobile-img{
        display: block;
        margin-left: auto;
        width: 50%;
      }
  
      h2{
        font-size: 32px;
        line-height: 40px;
      }
    }

    .desktop-img{
      display: none;
    }
  
    .login-now{
      padding: 2px 4px;
      left: 45%;
      top: 30%;
      font-size: 12px;
      line-height: 20px;
    }
  }

  @media screen and (max-width: 425px) {
    .container {
      padding: 2rem 0px 2rem 1.25rem;
      flex-direction: column;
    }

    img{
      min-height: 150px;
    }
  
    .content{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 28px;
      flex-shrink: 0;
      width: 100%;
      
      .mobile-img{
        display: block;
        margin-left: auto;
        width: auto;
      }
  
      h2{
        font-size: 32px;
        line-height: 40px;
      }
    }

    .desktop-img{
      display: none;
    }
  
    .login-now{
      padding: 2px 4px;
      left: 10%;
      top: 41%;
      font-size: 12px;
      line-height: 20px;
    }
  }
  @media screen and (min-width: 768px) {
    .content{
      padding-right: 50px;
    }
  }
`;

const BannerNew = ({ title }) => {
  return (
    <Wrapper>
      <div className="container">
        <div className="content">
          <h2>{title}</h2>
          <img
            loading="lazy"
            src={BannerImageMobile}
            alt="Best floral website templates and innovative website design features for florists"
            className="mobile-img"
          />
          <Link className="text-decoration-none" to="/signup">
            <ActionButton>
              Get Started
              <ButtonArrowIcon />
            </ActionButton>
          </Link>
        </div>

        <img
          loading="lazy"
          src={BannerImage}
          alt="Best floral website templates and innovative website design features for florists"
          className="desktop-img"
        />

        <button className="login-now">Login now</button>
      </div>
    </Wrapper>
  );
};

export default BannerNew;
